// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.client.enums.TourStatusForZcheduler

export enum TourStatusForZcheduler {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  NO_SHOW = 'NO_SHOW',
  REQUESTED = 'REQUESTED',
}

export const TourStatusForZcheduler_values = [
  TourStatusForZcheduler.CANCELLED,
  TourStatusForZcheduler.COMPLETED,
  TourStatusForZcheduler.CONFIRMED,
  TourStatusForZcheduler.DECLINED,
  TourStatusForZcheduler.EXPIRED,
  TourStatusForZcheduler.NO_SHOW,
  TourStatusForZcheduler.REQUESTED,
] as const;
